<template>
    <div class="row footerBackgroudColor">
        <div  class=" col-md-12 divCenterOne">
            <div class=" col-md-4 divCenterOneImage">
                <img src="../assets/img/account/developer-3.png" alt="">
            </div>
            <div class=" col-md-4 col-md-offset-4 divLanguageClassTwo" style="font-size:20px;">
                <div class="divLanguageClass">
                    <span class="spanGrowClass"></span>
                    <span class="developer_footer_language ">{{$t('language')}}</span>
                    <div :inputDomClick="'inputDomClick'" class="divInputImageClass">
                        <!-- <input :inputDomClick="true" type="text"  @click="clickDivFunc" :value="languageChoose" class="rectangle_4" readonly="readonly"/> -->
                        <input :inputDomClick="'inputDomClick'" :class="$store.state.globalSelectControlState === 'inputDomClick' ? 'rectangle_4_true' : ''" type="text"  @click="clickDivFunc" :value="languageChoose" class="rectangle_4" readonly="readonly"/>
                        <img :inputDomClick="'inputDomClick'" @click="clickDivFunc" class="selectImage" src="../assets/img/account/selectImage.png" alt="">
                        <div :inputDomClick="'input'" class="positionSelect" :style="$store.state.globalSelectControlState === 'inputDomClick'  ? 'display:block' : 'display:none'">
                            <!-- <p @click="$_admin_dash_change_lang('en')" :style="englishColor ? 'color:#000' : 'color:#888888;'">English</p> -->
                            <!-- <p @click="$_admin_dash_change_lang('zh-TW')" :style="chineseFTColor ? 'color:#000' : 'color:#888888;'">繁體中文</p> -->
                            <!-- <p @click="$_admin_dash_change_lang('zh-CN')" :style="chineseJTColor ? 'color:#000' : 'color:#888888;'">简体中文</p> -->
                            <p :inputDomClick="'inputDomClick'" @click="$_admin_dash_change_lang('zh-TW')" v-show="!chineseFTColor" class="chineseFTColor">繁體中文</p>
                            <p :inputDomClick="'inputDomClick'" @click="$_admin_dash_change_lang('zh-CN')" v-show="!chineseJTColor" class="chineseJTColor">简体中文</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="col-md-12 divCenterOneImage divCenterOneImagePadding">
            <div class=" col-md-8 ">
                <span class="developer_footer_resources">{{ $t('footer.resources') }}</span>
                <span class="developer_footer_support ">{{ $t('footer.support') }}</span>
                <span class="developer_footer_about_nuwa">{{ $t('footer.aboutNuwa') }}</span>
            </div>
            <div class=" col-md-4  divCenterImageClassOne" >
                <div class="divCenterOneImagesClass">
                    <span class="spanGrowClass"></span>
                    <img @click.stop.prevent="imageClickFunc('facebook')" style="cursor: pointer;" class="facebookImage" src="../assets/img/account/facebook.png" alt="">
                    <img @click.stop.prevent="imageClickFunc('youtube')" style="cursor: pointer;" class="youtubeImage" src="../assets/img/account/youtube.png" alt="">
                    <div style="position:relative;">
                        <div class="wechatImagePosition" :style="wechatStyle">
                            <span class="spanPosition"></span>
                            <img @click.stop.prevent="imageClickFunc('wechat')" style="width: 86px;height: 86px;cursor: pointer;" src="../assets/img/account/wechat_qr_code.png"/>
                        </div>
                        <img @click.stop.prevent="imageClickFunc('wechat')" style="cursor: pointer;" class="wechatImage" src="../assets/img/account/wechat.png" alt="">
                    </div>
                </div>

            </div>
        </div>
        <div class=" col-md-12">
            <div class=" col-md-8 developer_footer_div_class" >
             <div class="developer_footer_resources_div_class">
                 <ul class="ul_one ul_one_width">
                     <li style="cursor: pointer;" @click="isFileFunc('design')" class="developer_footer_resources_design_guideline"><span>{{ $t('footer.designGuideilnes') }}</span></li>
                     <li style="cursor: pointer;" @click="isFileFunc('sdk')" class="developer_footer_resources_design_guideline margin_li"><span>{{ $t('footer.nuwaRobotSDK') }}</span></li>
                     <li style="cursor: pointer;" @click="isFileFunc('motion')" class="developer_footer_resources_design_guideline"><span>{{ $t('footer.motionList') }}</span></li>
                 </ul>
                   <ul class="ul_one ul_marin">
                     <li style="cursor: pointer;" @click="isFileFunc('forums')" class="developer_footer_resources_design_guideline"><span>{{ $t('footer.forums') }}</span></li>
                     <!-- <li class="developer_footer_resources_design_guideline margin_li"><span>{{ $t('footer.bugReport') }}</span></li> -->
                     <a :href="contact" class="developer_footer_resources_design_guideline margin_li"><span>{{ $t('footer.bugReport') }}</span></a>
                     <a :href="contact" class="developer_footer_resources_design_guideline"><span>{{ $t('footer.contactUs') }}</span></a>
                 </ul>
                   <ul class="ul_one">
                     <li @click="isFileFunc('home')" style="cursor: pointer;" class="developer_footer_resources_design_guideline"><span>{{ $t('footer.nuwaHompage') }}</span></li>
                     <li :style="chineseFTColor ? 'cursor: pointer;' : ''" @click="isFileFunc('job')" class="developer_footer_resources_design_guideline margin_li"><span>{{ $t('footer.jobOpportunities') }}</span></li>
                     <li @click="isFileFunc('buy')" style="cursor: pointer;" class="developer_footer_resources_design_guideline"><span>{{ $t('footer.buyNUWARobot') }}</span></li>
                 </ul>
             </div>
            </div>
        </div>
        <div class=" col-md-12 divCenterOneImagePaddingAll">
            <div class=" col-md-6 divCenterOneImage" >
                <p class="developer_footer_copyright">Copyright © 2018 Nuwa Robotics. All rights reserved.</p>
            </div>
             <div class=" col-md-6 divCenterOneImagePaddingLeft" >
                 <div class="developer_footer_about_div">
                     <span class="spanGrowClass"></span>
                     <a :href="terms" class="developer_footer_about_nuwa_terms_and_agreements ">{{ $t('footer.termsAndAgreements') }}</a>
                     <span class="layer">|</span>
                     <a :href="pricacy" class="developer_footer_privacy_policy">{{ $t('footer.privacyPolicy') }}</a>
                 </div>
            </div>
        </div>
    </div>
</template>

<script>
// import config from '../config'
export default {
    data () {
        let protocol = window.location.protocol
        let env = window.location.hostname.split('.')[0]
        let forumPort = env === 'localhost' ? '4567' : '80'
        if (protocol === 'https:') {
            forumPort = '443'
        }
        env = window.location.hostname
        return {
            styleDisplay: false,
            chineseFTColor: false,
            chineseJTColor: false,
            englishColor: true,
            languageChoose: 'English',
            // [link]
            terms: 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html',
            pricacy: 'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html',
            nuwaHome: '',
            nvwa: 'https://www.nuwarobotics.',
            forumUrl: protocol + '//' + env + ':' + forumPort + '/forum/',
            // [繁中]
            job: 'https://goo.gl/LqEuKh',
            contact: 'mailto:service@nuwarobotics.com',
            designGuideilnes: '',
            nuwaSdk: '',
            motionList: '',
            facebookUrl: 'https://www.facebook.com/NuwaRobotics',
            youtubeUrl: 'https://www.youtube.com/channel/UCtGr2QTF4B6DLm2GEHbLPeQ',
            wechatFlag: false,
            wechatStyle: 'opacity: 0;display:none;',
            env: env,
            base: '',
            path: '',
            frontPort: '8070'
        }
    },
    methods: {
        clickDivFunc () {
            if (this.styleDisplay === true) {
                this.styleDisplay = false
                this.$store.state.styleDisplay = false
                return
            }
            this.$store.state.styleDisplay = true
            this.styleDisplay = true
        },
        imageClickFunc (imageType) {
            switch (imageType) {
                case 'facebook':
                    window.location.href = this.facebookUrl
                    break
                case 'youtube':
                    window.location.href = this.youtubeUrl
                    break
                case 'wechat':
                    if (!this.wechatFlag) {
                        this.wechatFlag = true
                        this.wechatStyle = 'opacity: 1;display:block;'
                    } else {
                        this.wechatFlag = false
                        this.wechatStyle = 'opacity: 0;display:none;'
                    }
                    break
                default:
            }
        },
        isFileFunc (type) {
            switch (type) {
                case 'design':
                    this.fileDetailFunc()
                    sessionStorage.setItem('cliclkFile', 'true')
                    break
                case 'sdk':
                    this.fileDetailFunc('sdk')
                    sessionStorage.setItem('cliclkFile', 'true')
                    break
                case 'motion':
                    sessionStorage.setItem('cliclkFile', 'true')
                    this.fileDetailFunc('motion')
                    break
                case 'forums':
                    //         if (
                    //             sessionStorage.registeredDetail === 'true' &&
                    // localStorage.token !== undefined
                    //         ) {
                    window.location.href = this.forumUrl
                    // } else {
                    //     this.$store.state.borderStyle = 'login'
                    //     localStorage.setItem('clickState', 'login')
                    //     this.$router.push({ name: 'userLogin' })
                    // }
                    break
                case 'job':
                    if (localStorage.language === 'zh-TW') {
                        window.location.href = this.job
                    }
                    break
                case 'home':
                case 'buy':
                    if (localStorage.language === 'zh-TW') {
                        this.nuwaHome = this.nvwa + 'com/'
                    } else if (localStorage.language === 'zh-CN') {
                        this.nuwaHome = this.nvwa + 'cn/'
                    }
                    window.location.href = this.nuwaHome
                    break
                default:
            }
        },
        fileDetailFunc (type) {
            if (
                sessionStorage.registeredDetail === 'true' &&
        localStorage.token !== undefined
            ) {
                this.$store.state.borderStyle = 'file'
                localStorage.clickState = 'file'
                if (type === 'motion') {
                    this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + '/documents/listMotionFile' : this.path = this.base + '/documents/listMotionFile'
                    window.location.href = this.path
                    this.$store.state.borderStyle = 'file'
                    localStorage.setItem('clickState', 'file')
                    this.$store.state.isSideBarShow = type
                    sessionStorage.isSideBarShow = type
                } else if (type === 'sdk') {
                    this.$store.state.borderStyle = 'file'
                    localStorage.setItem('clickState', 'file')
                    this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + '/documents/sdkDescription/robotSdk' : this.path = this.base + '/documents/sdkDescription/robotSdk'
                    window.location.href = this.path
                    this.$store.state.isSideBarShow = type
                    sessionStorage.isSideBarShow = type
                } else {
                    this.env === 'localhost' ? this.path = this.base + ':' + this.frontPort + '/documents/intro' : this.path = this.base + '/documents/intro'
                    window.location.href = this.path
                }
            } else {
                this.$store.state.borderStyle = 'login'
                localStorage.setItem('clickState', 'login')
                this.$router.push({ name: 'userLogin' })
            }
        },
        $_admin_dash_change_lang (lang) {
            this.styleDisplay = false
            this.$root.$i18n.locale = lang
            this.$store.state.switchLanguage = lang
            localStorage.setItem('language', lang)
            if (lang === 'en') {
                this.englishColor = true
                this.chineseFTColor = false
                this.chineseJTColor = false
                this.languageChoose = 'English'
                this.terms = 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html'
                this.pricacy =
          'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html'
            } else if (lang === 'zh-TW') {
                this.chineseFTColor = true
                this.englishColor = false
                this.chineseJTColor = false
                this.languageChoose = '繁體中文'
                this.terms = 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html'
                this.pricacy =
          'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html'
            } else {
                this.chineseFTColor = false
                this.englishColor = false
                this.chineseJTColor = true
                this.languageChoose = '简体中文'
                this.terms = 'https://user-privacy.nuwarobotics.cn/zh-cn/terms.html'
                this.pricacy =
          'https://user-privacy.nuwarobotics.cn/zh-cn/privacy.html'
            }
            this.$root.$emit('langChanged', lang)
        }
    },
    mounted () {
        // 根据环境拼接url
        let protocol = window.location.protocol
        let splitLine = '//'
        let env = window.location.hostname
        let path = protocol + splitLine + env
        this.env = env
        this.base = path
        if (this.$store.state.switchLanguage === 'en') {
            this.englishColor = true
            this.chineseFTColor = false
            this.chineseJTColor = false
            this.languageChoose = 'English'
            this.terms = 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html'
            this.pricacy = 'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html'
        } else if (this.$store.state.switchLanguage === 'zh-TW') {
            this.chineseFTColor = true
            this.englishColor = false
            this.chineseJTColor = false
            this.languageChoose = '繁體中文'
            this.terms = 'https://user-privacy.nuwarobotics.cn/zh-tw/terms.html'
            this.pricacy = 'https://user-privacy.nuwarobotics.cn/zh-tw/privacy.html'
        } else {
            this.chineseFTColor = false
            this.englishColor = false
            this.chineseJTColor = true
            this.languageChoose = '简体中文'
            this.terms = 'https://user-privacy.nuwarobotics.cn/zh-cn/terms.html'
            this.pricacy = 'https://user-privacy.nuwarobotics.cn/zh-cn/privacy.html'
        }
    },
    computed: {
    },
    watch: {
    }
}
</script>

<style scoped>
.ul_one_width {
  width: 127px;
}
.spanPosition {
  width: 0px;
  height: 0px;
  position: absolute;
  bottom: -6px;
  right: 15px;
  border-top: 6px solid rgb(255, 255, 255);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
.chineseFTColor{
    color: #ffffff;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.chineseJTColor{
    color: #ffffff;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.wechatImagePosition {
  position: absolute;
  width: 84px;
  height: 85px;
  padding: 7px;
  top: -119px;
  right: 0px;
  z-index: 5;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  flex-direction: column;
  opacity: 1;
  transition: opacity 0.2s ease-out 0s, transform 0.12s ease-out 0.08s;
  transform: scale(1) translate(0px, 0px);
}
.rectangle_4_true{
  border-bottom-left-radius: 0px!important;
  border-bottom-right-radius: 0px!important;
}
.positionSelect {
    position: absolute;
    left: 0;
    top: 28px;
    width: 118px;
    /* height: 54px; */
    padding-top: 3px;
    /* background: #ffffff; */
    z-index: 1;
    border-radius: 5px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    background-color: rgba(133, 133, 133, 1);
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #000;
    outline: none;
    border: none;
    cursor: pointer;
    margin-top: -1px;
}
.positionSelect p{
    margin: 0;
    padding-top: 2px;
    padding-left: 8px;
    height: 27px;
}
.positionSelect p:hover{
    background: #b8b8b8;
}
li {
  list-style: none;
}
.selectImage {
  width: 14px;
  height: 10px;
  position: absolute;
  right: 12px;
  top: 12px;
}
.ul_one {
  padding: 0;
}
.developer_footer_about_div {
  display: flex;
}
.divCenterOneImagePaddingLeft {
  padding-right: 100px;
  opacity: 0.5;
}
.divCenterOneImagePaddingAll {
  padding-top: 32px;
  padding-bottom: 24px;
  display: flex;
  justify-content: space-between;
}
.layer {
  width: 5px;
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #ffffff;
  margin: 0px 16px;
}
.developer_footer_privacy_policy {
  /* width: 102px; */
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #ffffff;
  text-align: right;
}
.developer_footer_privacy_policy:hover{
  border-bottom: solid 1px rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
}
.developer_footer_about_nuwa_terms_and_agreements {
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #ffffff;
  text-align: right;
}
.developer_footer_about_nuwa_terms_and_agreements:hover{
  border-bottom: solid 1px rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
}
.developer_footer_copyright {
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #ffffff;
  margin: 0;
}
.ul_marin {
  width: 80px;
  margin-left: 83px;
  margin-right: 129px;
}

.margin_li {
  margin-top: 2px;
  margin-bottom: 2px;
}
.developer_footer_div_class {
  padding-left: 101px;
}
.developer_footer_resources_div_class {
  display: flex;
}
.developer_footer_resources_design_guideline {
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #ffffff;
  opacity: 0.5;
  display: table !important;
}
.developer_footer_resources_design_guideline > span:hover {
  border-bottom: solid 1px rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
}
.divCenterImageClassOne {
  padding-right: 100px;
}
.divCenterOneImagesClass {
  display: flex;
  padding: 0;
}
.divCenterOneImage {
  padding-left: 100px;
  display: flex;
  justify-content: space-between;
}
.facebookImage {
  width: 26px;
  height: 30px;
}
.youtubeImage {
  width: 26px;
  height: 30px;
  margin-right: 14px;
  margin-left: 16px;
}
.wechatImage {
  width: 35px;
  height: 30px;
}
.developer_footer_resources {
  width: 210px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: #ffffff;
  text-align: left;
  display: inline-block;
}
.developer_footer_support {
  width: 211px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: #ffffff;
  text-align: left;
  display: inline-block;
}
.developer_footer_about_nuwa {
  width: 190px;
  height: 33px;
  font-family: sans-serif;
  font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.2px;
  color: #ffffff;
  text-align: left;
  display: inline-block;
}

.divCenterOne {
  padding-top: 28px;
  padding-bottom: 18px;
  display: flex;
  justify-content: space-between;
}
.divInputImageClass {
  margin-right: 100px;
  position: relative;
  cursor: pointer;
}
.rectangle_4 {
  width: 118px;
  height: 27px;
  border-radius: 5px;
  background-color: rgba(216, 216, 216, 0.5);
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: rgba(255, 255, 255, 1);
  outline: none;
  border: none;
  padding-left: 8px;
  cursor: pointer;
  box-sizing: border-box;
}
.developer_footer_language {
  width: 68px;
  height: 20px;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  color: #ffffff;
  line-height: 28px;
  margin-right: 12px;
  opacity: 0.5;
  text-align: right;
}
.divLanguageClassTwo {
  padding: 0;
}
.spanGrowClass {
  display: flex;
  flex-grow: 1;
}
.divLanguageClass {
  display: flex;
}
.footerBackgroudColor {
  background: #333;
  padding: 0;
}
</style>
